import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SubmitCard from '@/components/card/submit-card-component';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import { Col, Row } from '@/components/grid/grid-component';
import { Subtitle2Text } from '@/utils/global-fonts';
import PropTypes from 'prop-types';
import getCompanyTemplatesSelectApi from '@/api/get/company/company-template/get-company-templates-select';
import SelectSearch from '@/components/react-hook-form-inputs/select-search/select-search-component';
import RadioInput from '@/components/react-hook-form-inputs/radio-button/radio-button-component';
import { useFormContext } from 'react-hook-form';
import { useLazyQuery } from '@/hooks/use-api';

const modalRowStyle = {
  marginLeft: '0px',
  marginRight: '0px',
  marginBottom: '0px',
  marginTop: '0px',
};

const modalParentRowStyle = {
  marginLeft: '0px',
  marginRight: '0px',
  marginBottom: '0px',
  padding: '24px',
};

const styledCol = {
  paddingLeft: '0px',
};

const selectColStyle = {
  paddingLeft: '15px',
};

const selectRowStyle = { marginTop: 18, marginBottom: 0 };

const radioContainerStyle = { width: '100%' };
const mainContainerStyle = { width: '80%', marginLeft: 5 };

const NewProductForm = ({ options }) => {
  const { formState, control, watch, setValue } = useFormContext();

  const createFromTemplate = watch('createFromTemplate');

  return (
    <Row style={modalParentRowStyle}>
      <>
        <Row style={modalRowStyle}>
          <Col xs={12} style={styledCol}>
            <Subtitle2Text>
              Would you like to create a new product from a template or start
              from scratch?
            </Subtitle2Text>
          </Col>
        </Row>
        <Row style={modalRowStyle}>
          <Col xs={12} style={styledCol}>
            <RadioInput
              radioContainerStyle={radioContainerStyle}
              mainContainerStyle={mainContainerStyle}
              options={[{ value: 'from_template', label: 'From Template' }]}
              name="createFromTemplate"
              registerOptions={{
                onChange: (v) => {
                  if (v.target.value === 'from_template') {
                    // Deselect the new product radio button
                    setValue(`createNewProduct`, false);
                  }
                },
              }}
              formState={formState}
              control={control}
            />
          </Col>
        </Row>
        {createFromTemplate && (
          <Row style={selectRowStyle}>
            <Col
              style={selectColStyle}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
            >
              <SelectSearch
                cy="selDropdown"
                label="Please Select"
                name="templateId"
                options={options}
                onChange={(e) => {
                  setValue(`templateId`, e.value);
                }}
              />
            </Col>
          </Row>
        )}
        <Row style={modalRowStyle}>
          <Col xs={12} style={styledCol}>
            <RadioInput
              radioContainerStyle={radioContainerStyle}
              mainContainerStyle={mainContainerStyle}
              options={[{ value: 'new_product', label: 'New Product' }]}
              name="createNewProduct"
              registerOptions={{
                onChange: (v) => {
                  if (v.target.value === 'new_product') {
                    // Deselect the from template radio button
                    setValue(`createFromTemplate`, false);
                    setValue(`templateId`, null);
                  }
                },
              }}
              formState={formState}
              control={control}
            />
          </Col>
        </Row>
      </>
    </Row>
  );
};

NewProductForm.propTypes = {
  options: PropTypes.array.isRequired,
};

/**
 * @param {object} root0 - The root object containing props
 * @param {boolean} root0.open - open
 * @param {Function} root0.onClose - Callback function to close the modal
 * @returns {JSX.Element} - The rendered JSX element
 */
const NewProductModal = ({ open, onClose }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { refetch, data } = useLazyQuery(getCompanyTemplatesSelectApi);

  useEffect(() => {
    if (open) {
      refetch(id);
    }
  }, [id, open, refetch]);

  const submitForm = (values) => {
    if (values) {
      if (values?.createNewProduct) {
        navigate('new');
      } else {
        // get selected template and navigate to new product page
        navigate('new', {
          state: { templateId: values?.templateId },
        });
      }
    }
  };

  return (
    <FormWrapper defaultValues={{}} onSubmit={submitForm}>
      <NewProductForm
        options={data?.map((option) => ({
          value: option.id,
          label: option.name,
        }))}
      />
      <SubmitCard
        padding="0"
        primaryButtonTitle="Create"
        primaryButtonType="submit"
        primaryButtonDisabled={false}
        primaryButtonWidth="112px"
        submitClick={() => {}}
        submitClickSecondary={() => {
          onClose();
        }}
        secondaryButtonType="button"
        secondaryButtonDisabled={false}
        secondaryButtonWidth="112px"
        disabled={false}
        secondaryButtonTitle="Cancel"
      />
    </FormWrapper>
  );
};

NewProductModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NewProductModal;
